@if (!isCarrierUserRecruiter()) {
    <div [ngClass]="{'side-rail': true, 'collapsed': !isExpanded}" *appAuthorize="'sideRail'">
        <div *ngFor="let navItem of navigationOptions"
             [ngClass]="{'side-rail-item': true, 'active': isActive(navItem)}">
            <ng-template #label>
                <div>{{navItem.label}}</div>
            </ng-template>

        <a *ngIf="navItem.children.length <= 1" [routerLink]="convertRouteToPath(navItem.route)" [attr.atid]="navItem.atid" [ngbPopover]="label"
           placement="end" popoverClass="flyout-side-rail-popover" triggers="hover focus:blur" [disablePopover]="isExpanded"
           [closeDelay]="closeDelayTime">
            <div class="side-rail-icon"><img src="{{navItem.imageFile}}" alt="{{isExpanded? '' : navItem.label}}"/></div>
            <ng-container *ngIf="isExpanded" [ngTemplateOutlet]="label"></ng-container>
        </a>

            <app-dropdown *ngIf="navItem.children.length > 1"
                          menuClass="side-rail-sub-menu suif-menu-dark"
                          toggleClass=""
                          [placement]="['end-top']"
                          [attr.atid]="navItem.atid">
                <ng-container toggleContent>
                    <!-- TODO: this trigger is competing with the dropdown, need a way for these to behave together -->
                    <div class="side-rail-icon" [ngbPopover]="label" popoverClass="flyout-side-rail-popover has-child"
                         placement="end" triggers="hover focus:blur" [disablePopover]="isExpanded" [closeDelay]="closeDelayTime">
                        <img src="{{navItem.imageFile}}" alt=""/>
                    </div>
                    <ng-container *ngIf="isExpanded" [ngTemplateOutlet]="label"></ng-container>
                </ng-container>

            <ng-container menuContent class="suif-menu-body">
                <a *ngFor="let subTab of navItem.children" [routerLink]="convertRouteToPath(subTab.route)" [attr.atid]="subTab.atid">{{subTab.label}}</a>
            </ng-container>
        </app-dropdown>
    </div>

        <div class="side-rail-toggle">
            <button class="side-rail-toggle-button" type="button" (click)="toggleSideRailExpand()">
                <fa-icon *ngIf="isExpanded" [icon]="faAnglesLeft" size="sm" aria-hidden="true"></fa-icon><span class="visually-hidden">collapse siderail</span>
                <fa-icon *ngIf="!isExpanded" [icon]="faAnglesRight" size="sm" aria-hidden="true"></fa-icon><span class="visually-hidden">expand siderail</span>
            </button>
        </div>
    </div>
}
